import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorker } from './swRegister';

// Benannter Browser-Kontext: Links aus Benachrichtigungen laden im bereits
// offenen App-Tab statt einen neuen zu oeffnen (Muster powerCONTACT).
if (!window.name) window.name = 'powercare';

// Kein globaler fetch-Wrapper (anders als powerCONTACT): die Anmeldung ist ein
// httponly-Cookie vom Backend, das bei jedem same-origin-Request von selbst
// mitgeht. Es gibt kein Token, das angehaengt werden muesste.

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
registerServiceWorker();
